import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context/BreadcrumbsContext';
import { Error404 } from '../ErrorPages';
import { CreateOrganizationGroup, EditOrganizationGroup, OrganizationGroup } from './pages';

export const OrganizationsGroupEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Organizations Group',
      element: <OrganizationGroup />,
      path: '/',
      index: true,
    },
    {
      label: 'Edit Group',
      element: <EditOrganizationGroup />,
      path: ':id/edit',
    },
    {
      label: 'Create Group',
      element: <CreateOrganizationGroup />,
      path: '/',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
